import * as ActionTypes from "./ActionTypes";
import {ApiManager} from "../api/ApiManager";
import {IOrderEvent} from "../models/order/IOrderEvent"

export class OrderActions {

    static logOrderEventSuccess(orderEvent: IOrderEvent) {
        return {type: ActionTypes.FETCH_ACCOUNT_DATA_SUCCESS, orderEvent};
    }

    static logOrderEvent(dispatch: any, orderEvent: IOrderEvent) {
        /*return ApiManager.getAlbusApis().logOrderEvent(orderEvent).then((retOrderEvent: IOrderEvent) => {
            dispatch(OrderActions.logOrderEventSuccess(retOrderEvent));
        }).catch((error: any) => {
            console.error(error);
            throw (error);
        });*/

        return ApiManager.getAlbusApis().logOrderEvent(orderEvent);
    };

    static logRoomEvent(dispatch: any, reqBody: any, headers?: any) {
        return ApiManager.getAlbusApis().addTwilioRoomEventLog(reqBody, headers);
    }

}
